import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Container, Grid, Stack, TextField, Typography, useTheme, } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { SectionBox } from './sectionBox';
import { Config } from '../../config';
const config = new Config();
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const BookDemoSection = ({ title, bullets, formTitle, formSubtitle, emailPlaceholder = 'you@company.com', ctaText, footerText, scheduleUrl, industry, }) => {
    const theme = useTheme();
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const redirectToScheduler = () => {
        const sep = scheduleUrl.includes('?') ? '&' : '?';
        const url = `${scheduleUrl}${sep}email=${encodeURIComponent(email)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        if (!EMAIL_RE.test(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        setSubmitting(true);
        try {
            // Fire-and-forget capture: don't block the user from booking
            // even if the lead capture fails.
            await fetch(`${config.apiUrl}/public/demo-lead`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email,
                    source: 'landing_book_demo',
                    ...(industry ? { industry } : {}),
                }),
            }).catch(() => undefined);
            redirectToScheduler();
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx(SectionBox, { id: "book-demo", background: theme.palette.background.default, children: _jsx(Container, { maxWidth: "lg", children: _jsxs(Grid, { container: true, spacing: { xs: 6, md: 10 }, alignItems: "center", children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsxs(Stack, { spacing: 4, children: [_jsx(Typography, { variant: "h2", sx: { whiteSpace: 'pre-line', lineHeight: 1.2 }, children: title }), _jsx(Stack, { spacing: 3, children: bullets.map((b, i) => {
                                        const Icon = b.icon;
                                        return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "flex-start", children: [_jsx(Box, { sx: {
                                                        flexShrink: 0,
                                                        color: theme.palette.primary.main,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        pt: 0.5,
                                                    }, children: _jsx(Icon, { sx: { fontSize: 24 } }) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 600, children: b.title }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: b.description })] })] }, i));
                                    }) })] }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(Card, { elevation: 9, sx: { borderRadius: '12px' }, children: _jsx(CardContent, { sx: { p: { xs: 3, md: 4 } }, children: _jsxs(Stack, { component: "form", onSubmit: handleSubmit, spacing: 3, noValidate: true, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", fontWeight: 700, gutterBottom: true, children: formTitle }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: formSubtitle })] }), _jsx(TextField, { type: "email", label: "Work email", placeholder: emailPlaceholder, value: email, onChange: (e) => {
                                                setEmail(e.target.value);
                                                if (error)
                                                    setError(null);
                                            }, fullWidth: true, required: true, error: !!error, helperText: error || ' ', disabled: submitting, autoComplete: "email" }), _jsx(Button, { type: "submit", variant: "contained", size: "large", fullWidth: true, disabled: submitting, sx: { minHeight: 48, fontWeight: 600 }, children: submitting ? (_jsx(CircularProgress, { size: 22, color: "inherit" })) : (ctaText) }), _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { color: 'text.secondary' }, children: [_jsx(LockOutlinedIcon, { sx: { fontSize: 16 } }), _jsx(Typography, { variant: "caption", color: "text.secondary", children: footerText })] })] }) }) }) })] }) }) }));
};
